import { Controller } from "@hotwired/stimulus"

// Keeps a suffix (e.g. "€") positioned directly after the text typed into a
// left-aligned, full-width input, since a plain <input> can't grow to fit its
// own content with CSS alone.
export default class extends Controller {
  static targets = ["input", "suffix"]

  connect() {
    this.reposition = this.reposition.bind(this)
    this.reposition()
    this.inputTarget.addEventListener("input", this.reposition)
    window.addEventListener("resize", this.reposition)
  }

  disconnect() {
    this.inputTarget.removeEventListener("input", this.reposition)
    window.removeEventListener("resize", this.reposition)
  }

  reposition() {
    const input = this.inputTarget
    const suffix = this.suffixTarget
    const value = input.value

    if (!value) {
      suffix.classList.add("invisible")
      return
    }

    const measurer = this.measurer()
    const styles = window.getComputedStyle(input)
    measurer.style.fontFamily = styles.fontFamily
    measurer.style.fontWeight = styles.fontWeight
    measurer.style.fontSize = styles.fontSize
    measurer.style.letterSpacing = styles.letterSpacing
    measurer.textContent = value

    const gapPx = 4
    suffix.style.left = `${input.offsetLeft + measurer.offsetWidth + gapPx}px`
    suffix.classList.remove("invisible")
  }

  // Lazily create an offscreen span with the same font metrics for text measurement
  measurer() {
    if (!this._measurerEl) {
      const el = document.createElement("span")
      el.style.cssText = "position:absolute;visibility:hidden;white-space:pre;pointer-events:none;top:0;left:0"
      this.element.appendChild(el)
      this._measurerEl = el
    }
    return this._measurerEl
  }
}
